import { useState, useEffect, useContext } from 'react';
import { useQuery } from 'react-query';
import { TitleSection, CardRow, CardComponent, BottomSection, PopupConfimation, Docker, Loader, Conditional, ConditionalDetails, AddEvent, Toaster, ButtonRow, Popup, ListCard, NoRecord } from 'components/generic';
import { conditionCreateObj, eventCreateObj, factCreateObj } from 'interface';
import * as api from 'actions';
import { useInView } from 'react-intersection-observer';
import { headerTab, listRequestObj, dockerList, conditionSearchList, popup } from 'config';
import { find, isEmpty, map } from 'lodash';
import { ReferenceContext } from 'providers';

import './style.scss';
import { Images } from 'assets/Images';

export default function ConditionalMaintenance() {

    // response objects
    const referenceData = useContext(ReferenceContext);
    const [resObj, setResponse] = useState(listRequestObj);
    const [createObj, setCreateObj] = useState(conditionCreateObj);
    const [eventList, setEventList] = useState([{ value: 'add-event', label: 'Add new event' }]);
    const [eventObj, setEventObj] = useState(eventCreateObj);
    const [createFactObj, setCreateFactObj] = useState(factCreateObj);

    const [conditionList, setConditionList] = useState([]);
    const [factList, setFactList] = useState([]);
    const [expressionList, setExpressionList] = useState([]);
    const [activeTab, setActiveTab] = useState(headerTab[0].key);
    const [activeState, setActiveState] = useState('dashboard');
    const [selectlist, setSelectList] = useState([]);
    const [showDocker, setDocker] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [dockerState, setDockerState] = useState('');
    const [appList, setAppList] = useState([]);
    const [addCondition, setAddCondition] = useState(false);
    const [addEvent, setAddEvent] = useState(false);
    const [saveRule, setSaveRule] = useState(false);
    const [bottonState, setBottonState] = useState('');
    const [eventExists, setEventExists] = useState(false);
    const [conditionExists, setConditionExist] = useState(false);
    const [disbleEvent, setDisableEvent] = useState(true);
    const [disbleCondition, setDisableCondition] = useState(true);
    const [searchInput, setSearchInput] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showCheckPopup, setShowCheckPopup] = useState(false);
    const [attachedWorkflows, setAttachedWorkflows] = useState([]);

    const [ref, inView] = useInView();
    const [startIndex, setStartIndex] = useState(0);
    const [totalList, setTotalList] = useState(0);
    const [showDrop, setShowDrop] = useState(false);
    const [norecord, setNorecord] = useState(false);

    const [permission, setPermission] = useState([]);
    const [dockerData, setDockerData] = useState(dockerList);
    const [factExists, setFactExist] = useState(false);

    let selectedWorkflow = [];

    let createFact = true;
    const toggleObj = { cn_code: '', cn_version: '', cn_status: '' };
    const getObj = { cn_code: '', cn_version: '' };
    const createExpressionObj = { ...factCreateObj, fa_formulaType: 'FORMULA' };
    const factObj = { recordCount: -1, start_index: 0, sa_id: '' };
    const utilityOperator = find(referenceData?.referenceData, el => el.ard_factsOperatorList)?.ard_factsOperatorList;
    const dataType = find(referenceData?.referenceData, el => el.ard_dataType)?.ard_dataType?.map(ele => ({ label: ele.name, value: ele.value }));
    const severityList = find(referenceData?.referenceData, el => el.ard_severity)?.ard_severity?.map(ele => ({ label: ele.name, value: ele.value }));

    const loadPermission = () => {
        const allPermissions = api.decrypting(localStorage.getItem('_ro'));
        const parsedPermission = allPermissions ? JSON?.parse(allPermissions) : {};
        const dockerPermission = parsedPermission?.exception_maintenance?.map(el => el?.replace(/_.*/, '')?.toLowerCase());
        const docker = dockerList.filter(el => dockerPermission?.includes(el.key));
        setDockerData(docker);
        setPermission(parsedPermission.exception_maintenance);
    };
    // condition listing api
    const { refetch: refetchConditionList, isLoading } = useQuery(['getConditionalList', resObj], () => api.post('condition/list', resObj), {
        onSuccess: (data) => {
            resObj?.startIndex === 0 && setStartIndex(0);
            if (data?.data?.data?.length > 0) {
                resObj?.startIndex === 0 ? setConditionList(data?.data?.data[0]?.result) : setConditionList(state => ([...new Set([...state, ...data?.data?.data[0]?.result || []])]));
                setTotalList(data?.data?.data[0]?.total);
                refetchApplicationList();
            } else {
                setConditionList([]);
                setTotalList(0);
            }
        }, refetchOnWindowFocus: false, enabled: true
    });

    // application listing api
    const { refetch: refetchApplicationList } = useQuery(['getApplicationList', ''], () => api.get('application/list'), {
        onSuccess: (data) => {
            data && setAppList(data?.data?.data?.map(el => ({ value: el.sa_id, label: el.sa_name })));
        }, refetchOnWindowFocus: false, enabled: true
    });

    // event listing api
    const { data: eventListing, refetch: refetchEventList } = useQuery(['getEventByApplication', createObj?.sa_id], () => api.get(`event/list?sa_id=${createObj?.sa_id}`),
        { refetchOnWindowFocus: false, enabled: false });

    // fact listing api
    const { refetch: refetchFactList } = useQuery(['getFactList', factObj], () => api.getListing('fact/list', factObj), {
        onSuccess: (data) => {
            const [list1, list2] = [data?.data?.data?.filter(ele => ele?.fa_formulaType === 'DIRECT'), data?.data?.data?.filter(ele => ele?.fa_formulaType === 'FORMULA')]
            setFactList(list1); setExpressionList(list2);
        }, refetchOnWindowFocus: false, enabled: false
    });

    // toggle status api
    const { refetch: refetchToggle } = useQuery(['handleToggle', toggleObj], () => api.status(`/condition/disable/${toggleObj?.cn_code}/${toggleObj?.cn_version}`, toggleObj), {
        onSuccess: (data) => {
            data?.data?.code === 200 ? setError(false) : setError(true);
            setErrorMessage(data?.data?.message);
            refetchConditionList();
        }, refetchOnWindowFocus: false, enabled: false
    });

    // create event api
    const { refetch: refetchCreateEvent } = useQuery(['handleCreateEvent', eventObj], () => api.post('event/add', eventObj), {
        onSuccess: (data) => {
            data?.data?.code === 200 ? setError(false) : setError(true);
            setErrorMessage(data?.data?.message);
            refetchEventList(); setAddEvent(false); setAddCondition(true);
            setCreateObj(state => ({ ...state, et_code: eventObj.et_code }), []);
            setEventObj({ et_name: '', et_code: '', et_description: '', sa_id: createObj.sa_id, et_status: 'A' });
        }, refetchOnWindowFocus: false, enabled: false
    });

    // create condition api
    const { refetch: refetchCreateCondition } = useQuery(['createConditional', createObj], () => api.create('condition/add', createObj), {
        onSuccess: (data) => {
            data?.data?.code === 200 ? setError(false) : setError(true);
            setErrorMessage(data?.data?.message);
            data?.data?.code === 200 && reset();
        }, refetchOnWindowFocus: false, enabled: false
    });

    // edit condition api
    const { refetch: refetchEditCondition } = useQuery(['createConditional', createObj], () => api.update('condition/edit', createObj), {
        onSuccess: (data) => {
            data?.data?.code === 200 ? setError(false) : setError(true);
            setErrorMessage(data?.data?.message);
            data?.data?.code === 200 && reset();
        }, refetchOnWindowFocus: false, enabled: false
    });

    // get condition by id api
    const { refetch: refetchGetById } = useQuery(['handleEdit', getObj], () => api.get(`condition/details/${getObj.cn_code}/${getObj.cn_version}`), {
        onSuccess: (editObj) => {
            factObj.sa_id = editObj?.data?.data[0]?.sa_id;
            const obj = {
                cn_name: dockerState === 'copy' ? '' : editObj?.data?.data[0]?.cn_name, cn_description: dockerState === 'copy' ? '' : editObj?.data?.data[0]?.cn_description, cn_mode: editObj?.data?.data[0]?.cn_mode,
                sa_id: editObj?.data?.data[0]?.sa_id, et_code: editObj?.data?.data[0]?.et_code, cn_status: editObj?.data?.data[0]?.cn_status, cn_rule: editObj?.data?.data[0]?.cn_rule, cn_version: editObj?.data.data[0]?.cn_version,
                cn_severity: editObj?.data?.data[0]?.cn_severity, et_name: editObj?.data?.data[0]?.et_name, cn_code: editObj?.data?.data[0]?.cn_code
            }
            createExpressionObj.sa_id = '';
            setCreateFactObj(state => ({ ...state, sa_id: editObj?.data?.data[0]?.sa_id, et_code: editObj?.data?.data[0]?.et_code, et_name: editObj?.data?.data[0]?.et_name }));
            setCreateObj(state => ({ ...state, ...obj }), []);
            refetchFactList();
            setTimeout(() => refetchEventList(), 200);
            dockerState === 'copy' ? setAddCondition(true) : setActiveState('conditional');
        }, refetchOnWindowFocus: false, enabled: false
    });

    // check event does exist
    const { refetch: doesEventExist } = useQuery(['doesExist', eventObj.et_code], () => api.get(`event?et_name=${eventObj?.et_name}&et_code=${eventObj?.et_code}&sa_id=${createObj.sa_id}`), {
        enabled: false, onSuccess: (eventEx) => { setEventExists(eventEx?.data?.data) }, refetchOnWindowFocus: false
    });

    // check event does exist
    const { refetch: doesConditionExist } = useQuery(['doesExist'], () => api.get(`condition/${encodeURIComponent(createObj?.cn_name)}`), {
        onSuccess: (conditionEx) => { conditionEx?.data?.data?.length === 0 ? setConditionExist(false) : setConditionExist(true) },
        refetchOnWindowFocus: false, enabled: false
    });

    // create fact
    const { refetch: refetchCreateFact } = useQuery(['createFact'], () => api.create('fact/add', createFact ? createFactObj : createExpressionObj), {
        onSuccess: (data) => {
            data?.data?.code === 200 ? setError(false) : setError(true);
            setErrorMessage(data?.data?.message);
            factObj.sa_id = createObj.sa_id;
            refetchFactList();
            setCreateFactObj(state => ({ ...factCreateObj, sa_id: createObj?.sa_id, et_code: createObj?.et_code, et_name: createObj?.et_name }));
        }, refetchOnWindowFocus: false, enabled: false
    });

    // check fact does exist
    const { refetch: doesFactExist } = useQuery(['doesExist'], () => api.get(`/fact/${createFactObj?.fa_key}/${createFactObj?.fa_name}?sa_id=${createObj.sa_id}`), {
        onSuccess: (res) => setFactExist(res?.data?.data?.length === 0 ? false : res?.data?.data),
        refetchOnWindowFocus: false, enabled: false
    });

    // get attached workflow
    const { refetch: refetchAttachedWF } = useQuery(['attachedWF'], () => api.get(`/condition/link/workflow/${createObj?.cn_code}/${createObj?.cn_version}`), {
        onSuccess: (res) => {
            const list = res?.data?.data[0]?.attachedWorkflow?.map(ele => ({ id: ele?.wf_name, ...ele }));
            if (list?.length > 0) {
                setAttachedWorkflows(list);
                setShowCheckPopup(true);
            } else {
                refetchEditCondition();
            }
        }, refetchOnWindowFocus: false, enabled: false
    });

    useEffect(() => {
        if (inView) {
            if (startIndex < totalList - 20) {
                setStartIndex(startIndex + 20);
                setResponse(state => ({ ...state, startIndex: startIndex + 20 }), []);
            } else {
                return false;
            }
        } else {
            return false;
        }
    }, [inView]);

    useEffect(() => {
        const a = eventListing ? eventListing?.data?.data?.map(el => ({ value: el.et_code, label: el.et_name })) : [];
        setEventList([...[{ value: 'add-event', label: 'Add Event' }], ...a]);
    }, [eventListing]);

    useEffect(() => {
        eventObj?.et_code && eventObj?.et_name && doesEventExist();
    }, [eventObj?.et_code, eventObj?.et_name]);

    useEffect(() => {
        !isEmpty(createObj.cn_name) && dockerState !== 'edit' && doesConditionExist();
    }, [createObj?.cn_name]);

    useEffect(() => {
        createFactObj?.fa_name && createFactObj?.fa_key && doesFactExist();
    }, [createFactObj?.fa_name, createFactObj?.fa_key]);


    useEffect(() => {
        const disableSave = !(!eventExists && eventObj?.et_name?.length > 0 && eventObj?.et_code?.length > 0);
        setDisableEvent(disableSave);
    }, [eventObj, eventExists]);

    useEffect(() => {
        const disabled = !(!conditionExists && createObj?.sa_id?.length > 0 && createObj?.cn_name?.length > 0 && createObj?.et_code?.length > 0 && createObj?.cn_severity?.length > 0);
        setDisableCondition(disabled);
    }, [createObj, conditionExists]);

    useEffect(() => {
        errorMessage && setTimeout(() => setErrorMessage(''), 2000)
    }, [errorMessage]);

    useEffect(() => {
        loadPermission();
        setTimeout(() => setNorecord(true), 500)
    }, []);

    // handle tab click
    const handleTabClick = (e) => {
        setShowDrop(false);
        setActiveTab(e.key);
        setResponse(state => ({ ...state, startIndex: 0, sort: [{ id: e.key, value: -1 }] }), []);
        setTimeout(() => refetchConditionList(), 200);
    }

    // handle search
    const handleSearch = (e) => {
        setShowDrop(false);
        const filter = e ? [e.obj] : [];
        e ? setSearchValue(e.value) : setSearchValue('');
        e ? setSearchInput(e.input) : setSearchInput('');
        setResponse(state => ({ ...state, filter: filter, startIndex: 0 }), []) && refetchConditionList();
    }

    // handle add new condition
    const handleAdd = (e) => {
        setShowDrop(false);
        setSaveRule(false);
        setAddCondition(true);
        setDockerState('add');
    }

    // add condition select
    const addConditionSelect = (e, key) => {
        if (key === 'et_code' && e.value === "add-event") {
            setAddCondition(false);
            setAddEvent(true);
        } else {
            setCreateObj(state => ({ ...state, [key]: e.value }), []);
            if (key === 'sa_id' && e.label && e.value) {
                factObj.sa_id = e.value;
                setEventObj(state => ({ ...state, sa_id: e.value }), []);
                setCreateFactObj(state => ({ ...state, sa_id: e.value }), []);
                refetchFactList();
                setTimeout(() => refetchEventList(), 200);
            } else if (key === 'et_code' && e.label && e.value) {
                setCreateObj(state => ({ ...state, et_name: e.label }), []);
                setCreateFactObj(state => ({ ...state, et_code: e.value, et_name: e.label }), []);
            }
        }
    }

    // add condition input
    const addConditionInput = (e, key) => {
        setCreateObj(state => ({ ...state, [key]: e.target.value }), []);
    }

    // add event
    const addEventInput = ({ target: { name, value } }) => {
        setEventObj(state => ({ ...state, [name]: value }), []);
        setEventObj(state => ({ ...state, sa_id: createObj.sa_id }));
    }


    // handle add new condition
    const handleCreatePopup = (e) => {
        e === 'Create' && setActiveState('conditional');
        e === 'Create' ? setDockerState(dockerState) : setDockerState('');
        e === 'Cancel' && setCreateObj(conditionCreateObj);
        setAddCondition(false);
    }

    // handle docker
    const dockerClick = (e, state) => {
        setSaveRule(false);
        setDocker(false);
        setDockerState(state);
        setConditionExist(false);
        setSelectList([]);
        ['edit', 'copy', 'view'].includes(state) && handleEdit(e, state);
    }

    // handle event popup
    const handleEventPopup = (e) => {
        e === 'Cancel' && setAddEvent(false);
        e === 'Cancel' && setAddCondition(true);
        e === 'Cancel' && setEventObj(eventCreateObj);
        e === 'Create' && refetchCreateEvent();
        setEventExists(false);
        setConditionExist(false);
    }

    // handle card checkbox
    const handleChecked = (e, list) => {
        setShowDrop(false);
        if (e) {
            setDocker(true);
            setSelectList([list]);
        } else {
            setDocker(false);
            setSelectList([]);
        }
    }

    // handle bottom section
    const handleBottomSection = (e) => {
        setSaveRule(true);
        setBottonState(e);
        setShowPopup(true);
    }

    // handle confirmation
    const handleConfimation = (e) => {
        setShowPopup(false);
        setSelectList([]);
        (e === 'No') && setSaveRule(false);
        (e === 'Yes' && bottonState === 'Goback') && reset();
        (e === 'Yes' && bottonState === 'Goback') && setCreateObj(conditionCreateObj);
        (e === 'Yes' && bottonState === 'Save') && createConditional();
    }

    // handle create condition
    const createConditional = () => {
        if (dockerState === 'add' || dockerState === 'copy') {
            refetchCreateCondition();
        } else if (dockerState === 'edit') {
            createObj?.cn_mode === "PUBLISHED" ? refetchAttachedWF() : refetchEditCondition();
        }
    }

    // handle edit
    const handleEdit = (e, state) => {
        getObj.cn_code = e[0].cn_code;
        getObj.cn_version = e[0].cn_version;
        refetchGetById();
    }

    // handle toggle
    const handleToggle = (e, list) => {
        setShowDrop(false);
        toggleObj.cn_code = list?.cn_code;
        toggleObj.cn_version = list?.cn_version;
        toggleObj.cn_status = e ? 'A' : 'I';
        refetchToggle();
    }

    // handle modal submit
    const handleModalSubmit = (e) => {
        setCreateObj(state => ({ ...state, cn_name: e.name }), []);
        setCreateObj(state => ({ ...state, cn_description: e.description }), []);
        setCreateObj(state => ({ ...state, cn_severity: e.severity }), []);
    }

    // handle add fact
    const handleAddFact = (e) => {
        if (e?.type === 'fa_allowedDataType') {
            setCreateFactObj(state => ({ ...state, fa_allowedDataType: e?.e?.value }), []);
        } else if (e?.type === 'et_code') {
            e.obj?.target.checked ? setCreateFactObj(state => ({ ...state, et_code: 'ALL', et_name: 'ALL' }), []) : setCreateFactObj(state => ({ ...state, et_code: createObj?.et_code, et_name: createObj?.et_name }), []);
        } else {
            setCreateFactObj(state => ({ ...state, [e.target.name]: e.target.value }), []);
        }
        setCreateFactObj(state => ({ ...state, fa_formulaType: 'DIRECT' }), []);
    }

    // handle create fact
    const handleCreateFact = (e) => {
        createFact = true;
        e === 'Cancel' && setCreateFactObj(state => ({ ...factCreateObj, sa_id: createObj?.sa_id, et_code: createObj?.et_code, et_name: createObj?.et_name }));
        e === 'Create' && refetchCreateFact();
    }

    // handle create Expression
    const handleCreateExpression = (e) => {
        createFact = false;
        createExpressionObj.sa_id = createObj?.sa_id;
        createExpressionObj.fa_key = e?.key;
        createExpressionObj.fa_name = e?.name;
        createExpressionObj.fa_formula = e?.formula;
        createExpressionObj.fa_fields = e?.fields;
        createExpressionObj.fa_formulaType = 'FORMULA';
        refetchCreateFact();
    }

    // handle save rule
    const handleSaveRule = (e) => {
        setCreateObj(state => ({ ...state, cn_rule: e.rule }), []);
    }

    // handle status
    const handleStatus = (e, type) => {
        setCreateObj(state => ({ ...state, cn_mode: type }), []);
    }

    // handle toaster
    const handleToaster = (e) => {
        e === 'close' && setErrorMessage('');
    }

    const handlePopupChecked = (e) => {
        selectedWorkflow = e;
    }

    const handleSelectList = (e) => {
        // empty
     }

    const handleCheckPopupSubmit = (e) => {
        (e === 'Save') && setCreateObj(state => ({ ...state, wf_details: selectedWorkflow }), []);
        (e === 'Goback') && setAttachedWorkflows([]);
        (e === 'Save') && setTimeout(() => refetchEditCondition(), 200);
        setShowCheckPopup(false);
    }

    const handleTitleDrop = (val) => {
        setShowDrop(val);
    }

    const handleTitleSelectedDrop = (val, key) => {
        setShowDrop(false);
        const filter = [{ id: key, value: val }]
        setActiveTab(key);
        setResponse(state => ({ ...state, filter: filter, startIndex: 0 }), []);
    }

    // reset function
    const reset = () => {
        setCreateObj(conditionCreateObj);
        setActiveState('dashboard');
        setDockerState('');
        setFactList([]);
        setExpressionList([]);
        setDisableCondition(true);
        setDisableEvent(true);
        setCreateFactObj(factCreateObj);
        setEventExists(false);
        setConditionExist(false);
        refetchConditionList();
        setShowCheckPopup(false);
        selectedWorkflow = [];
    }

    if (isLoading) {
        if (startIndex === 0) {
            return <Loader loading={isLoading} />
        }
    }

    // card listing
    const cardList = conditionList?.length > 0 && map(conditionList, (el, i) => {
        return <CardComponent key={i} list={el} checked={selectlist.length > 0 && (selectlist[0]?._id === el._id)} handleToggle={handleToggle} handleChecked={handleChecked} checkbox toggle toggleOn={el.cn_status === 'A' ? true : false} />
    })

    return (
        <>
            {activeState === 'dashboard' &&
                <>
                    <TitleSection title="Exception" count={totalList} headerList={headerTab} tab search add={permission?.includes('ADD_CONDITION')} activeTab={activeTab} handleTabClick={(e) => handleTabClick(e)} handleAdd={handleAdd} handleSearch={handleSearch} searchList={conditionSearchList} cardList={conditionList} searchValue={searchValue} searchInput={searchInput} appList={appList} showDrop={showDrop} handleTitleDrop={handleTitleDrop} handleTitleSelectedDrop={handleTitleSelectedDrop} application={true} />
                    <CardRow>{cardList}</CardRow>
                    {conditionList?.length === 0 && norecord && <NoRecord></NoRecord>}
                    <span ref={ref} style={{ visibility: 'hidden' }}>Load More</span>
                </>
            }

            {addCondition && <ConditionalDetails createObj={createObj} dockerState={dockerState} disbleCondition={disbleCondition} conditionExists={conditionExists} appList={appList} eventList={eventList} severityList={severityList} addConditionSelect={addConditionSelect} addConditionInput={addConditionInput} handleCreatePopup={handleCreatePopup} />}

            {addEvent && <AddEvent eventObj={eventObj} eventExists={eventExists} disableSave={disbleEvent} handleCreatePopup={handleEventPopup} addEventInput={addEventInput} />}
            {activeState === 'conditional' &&
                <><div className="condition-layout">
                    <Conditional createObj={createObj} saveRule={saveRule} dockerState={dockerState} factList={factList} expressionList={expressionList} createFactObj={createFactObj} dataType={dataType} utilityOperator={utilityOperator}
                        addFactInput={handleAddFact} handleModalSubmit={handleModalSubmit} handleCreateFact={handleCreateFact} handleCreateExpression={handleCreateExpression} handleSaveRule={handleSaveRule} factExists={factExists} />
                </div><BottomSection disableSave={dockerState === 'view' || disbleCondition} handleButtonClick={handleBottomSection} />
                </>
            }

            {showDocker && <Docker dockerlist={dockerData} selectlist={selectlist} dockerClick={dockerClick} />}

            {errorMessage && <Toaster success={!error} error={error} header={error ? 'Oops!!! something went wrong' : 'Yay! Everything Worked!'} content={typeof (errorMessage) === 'string' ? errorMessage : ''} handleUndoClose={handleToaster} />}

            {showPopup && <PopupConfimation showstatus={bottonState === 'Save'} activeStatus={createObj?.cn_mode} handleChecked={handleStatus} heading="Warning" content={bottonState === 'Save' ? popup.save : popup.back} handleConfimation={handleConfimation} />}

            {showCheckPopup && <Popup small alignleft>
                <div className='popup-wrapper'>
                    <img src={Images.warning} alt="warning" />
                    <h5>The <span>"{createObj.cn_name}"</span> has been linked to the workflows below. To overwrite the version, please select the workflow</h5>
                </div>
                <ListCard list={attachedWorkflows} checkBox={true} handleChecked={handlePopupChecked} handleSelectList={handleSelectList} />
                <div className='buttons'><ButtonRow label="Goback" label1="Save" handleButtonClick={handleCheckPopupSubmit} /></div>
            </Popup>}
        </>
    )

}